import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../../consts/api";

export const useDeleteCategory = (categoryId, options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.deleteChartCategory(categoryId), dto),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.chartingFilterCategories],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
};
